import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IfFeatureOffDirective } from './if-feature-off.directive';
import { IfFeatureOnDirective } from './if-feature-on.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IfFeatureOnDirective,
    IfFeatureOffDirective
  ],
  providers: [],
  exports: [
    IfFeatureOnDirective,
    IfFeatureOffDirective
  ]
})
export class FeatureFlagsModule { }
